const getLinkWithUTMParams = (
  link: string,
  username: string,
  marbleId: string,
): string => {
  const hasUTMParams =
    link.includes('utm_source') ||
    link.includes('utm_medium') ||
    link.includes('utm_campaign') ||
    link.includes('utm_content');

  return (
    link +
    (hasUTMParams
      ? `${link?.includes('?') ? '&' : '?'}mrbl=${marbleId}`
      : `${
          link?.includes('?') ? '&' : '?'
        }utm_source=mrbl.bio&utm_medium=referral&utm_campaign=${username}&utm_content=${marbleId}&mrbl=${marbleId}`)
  );
};

export default getLinkWithUTMParams;
